import * as React from "react";
import { SubmitNewValueHandler } from "./use-renameable-grid-header-state";

type Props = {
    submitNewValue: SubmitNewValueHandler;
    collectionDisplayNames: Record<string, string>;
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    inputValue: string;
};
export const InputWrapper = ({ collectionDisplayNames, submitNewValue, inputValue, onChange }: Props) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    // Prevent drag&drop column. Useful for improving UX to allow select text
    React.useEffect(() => {
        if (inputRef.current) {
            inputRef.current.onmousedown = (e) => {
                e.stopImmediatePropagation();
            };
        }
    }, []);
    return (
        <input
            type="text"
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                e.stopPropagation();
                submitNewValue(e, collectionDisplayNames);
            }}
            ref={inputRef}
            onChange={onChange}
            value={inputValue}
        />
    );
};
